import { configureStore } from '@reduxjs/toolkit/react';
import { useDispatch, useSelector } from 'react-redux';
import jbpReducer from './reducers/jbpGeneralSlice';
import standingDataReducer from './reducers/standingDataSlice';

export const store = configureStore({
  reducer: {
    jbp: jbpReducer,
    standingData: standingDataReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
